// Video di presentazione della bottega (YouTube/Vimeo): anteprima con pulsante play,
// il lettore si carica solo al clic (niente cookie dei video prima della scelta del cliente).
import React, { useState } from 'react';
import { Play } from 'lucide-react';
import { parseVideo } from '../utils/video';
import { useShop } from './ShopContext';

export default function ShopVideo({ url, title, className = '' }) {
  const { style } = useShop();
  const [playing, setPlaying] = useState(false);
  const [thumbFailed, setThumbFailed] = useState(false);
  const video = parseVideo(url);
  if (!video) return null;
  return (
    <div className={`relative aspect-video overflow-hidden bg-slate-900 ${style.media} ${className}`} data-testid="shop-video">
      {playing ? (
        <iframe
          src={video.embedUrl}
          title={title || 'Video di presentazione'}
          className="absolute inset-0 w-full h-full"
          allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
          allowFullScreen
        />
      ) : (
        <button type="button" onClick={() => setPlaying(true)} className="group absolute inset-0 w-full h-full" aria-label="Guarda il video">
          {!thumbFailed && (
            <img
              src={video.thumbnailHd}
              alt=""
              className="absolute inset-0 w-full h-full object-cover opacity-90 transition-transform duration-700 group-hover:scale-105"
              onError={(e) => {
                if (video.provider === 'youtube' && !e.currentTarget.dataset.fallback) {
                  e.currentTarget.dataset.fallback = '1';
                  e.currentTarget.src = video.thumbnail;
                } else setThumbFailed(true);
              }}
            />
          )}
          <span className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-black/20" />
          <span className="absolute inset-0 flex items-center justify-center">
            <span className={`w-16 h-16 md:w-20 md:h-20 ${style.btn === 'rounded-none' ? '' : 'rounded-full'} bg-white/95 flex items-center justify-center shadow-xl transition-transform group-hover:scale-110`}>
              <Play className="w-7 h-7 md:w-8 md:h-8 text-shop-primary ml-1" fill="currentColor" />
            </span>
          </span>
          <span className="absolute bottom-4 left-4 text-white text-sm font-medium">Guarda il video</span>
        </button>
      )}
    </div>
  );
}
